import * as React from 'react';
const SvgConfirm = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 18, height: 18, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M12.712 6.682a.525.525 0 0 1 0 .743L7.886 12.25 5.288 9.652a.525.525 0 0 1 .742-.742l1.856 1.856 4.084-4.084a.525.525 0 0 1 .742 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M2.926 9a6.074 6.074 0 1 0 12.148 0A6.074 6.074 0 0 0 2.926 9M9 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2',
      clipRule: 'evenodd',
    }),
  );
export default SvgConfirm;
